import React from 'react';

export default React.createContext({
  facts: {},
  toggle: () => {},
});
